package com.wintermar.inspection.feature.presentation.template.landing

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.feature.domain.model.template.TemplateModel
import com.wintermar.inspection.util.Constant

class TemplateLandingState(
    private val onGetTemplate: (page: Int, pageSize: Int, isRefresh : Boolean) -> Unit,
    private val onGetDetailTemplate: (id: String, data: TemplateModel) -> Unit,
    private val onCreateNewInspection: (templateId: String) -> Unit,
) {
    var isLoading by mutableStateOf(false)
    var isLoadingDetailTemplate by mutableStateOf(false)
    var isLoadingCreateInspection by mutableStateOf(false)
    var page: Int by mutableStateOf(1)
    val pageSize: Int = Constant.PAGE_SIZE
    var showBottomSheet by mutableStateOf(false)
    var isRefreshing by mutableStateOf(false)

    var data by mutableStateOf(TemplateModel(data = emptyList(), total = 0))
    var detailTemplate by mutableStateOf(
        InspectionTemplateModel()
    )

    fun onNextPage() {
        page++
        onGetTemplate(page, pageSize,false)
    }

    fun onPreviousPage() {
        page--
        onGetTemplate(page, pageSize,false)
    }

    fun onShowBottomSheet(
        templateId: String
    ) {
        showBottomSheet = true
        onGetDetailTemplate(templateId, data)
    }

    fun onDismissBottomSheet() {
        showBottomSheet = false
    }

    fun onStartInspectionClicked(templateId: String) {
        onCreateNewInspection(templateId)
    }

    fun onRefresh() {
        page = 1
        isRefreshing = true
        onGetTemplate(page, pageSize, true)
    }
}
